/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const IntakeSeasonService = {

  async CheckSeasonUsed(RecordID) {
    const requestScreenData = {
      url: `api/AlmondcoIntakeSeason/${RecordID}/CheckSeasonUsed`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async deleteIntakeSeason(RecordId) {
    var url = "api/AlmondcoIntakeSeason";

    return await ApiService.delete(url, RecordId, "Guid");
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { IntakeSeasonService };
